import React, { useRef, useEffect, useState, useMemo } from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { useApp } from "../../hooks/useApp"
import { withFooter } from "./withFooter"
import NavigationFooter from "../Navigation/Footer/NavigationFooter"
import SubscribeFooter from "../Subscribe/SubscribeFooter"
import FooterCopyright from "./FooterCopyright"
import FooterBackToTop from "./FooterBackToTop"
import { BackgroundContainer, StyledContainer } from "../Styled/Container"

// const Container = styled(StyledContainer)`
//   ${tw`bg-light pt-3-2 pb-10 max-w-xl mx-auto md:py-10 px-1-6`}
// `
const Container = styled(StyledContainer)`
  ${tw`bg-light pt-2 pb-2 max-w-xl mx-auto md:pt-5 md:pb-0 px-1-6`}
`

const Row = styled.div`
  ${tw`w-full flex justify-between md:flex-row`}
  ${({ bottom }) => (bottom ? tw`flex-col mt-3-2 md:mt-20` : tw`flex-col`)}
`

const Desktop = styled.div`
  ${tw`hidden md:block`}
`
const Mobile = styled.div`
  ${tw`block md:hidden`}
`
function useIsInViewport(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false)

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), [])

  useEffect(() => {
    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [ref, observer])

  return isIntersecting
}

export const Footer = withFooter((): JSX.Element => {
  const { setFooter } = useApp()
  const footerInView = useRef(null)
  const isBrowser = typeof window !== `undefined`
  const isFooterInView = isBrowser ? useIsInViewport(footerInView) : null
  useEffect(() => {
    isFooterInView ? setFooter(true) : setFooter(false)
  })
  return (
    <BackgroundContainer ref={footerInView} background={`light`}>
      <Container width={`full`}>
        <Desktop>
          <Row>
            <NavigationFooter />
            <SubscribeFooter />
          </Row>
          <Row bottom>
            <FooterCopyright />
            <FooterBackToTop />
          </Row>
        </Desktop>
        <Mobile>
          <Row>
            <NavigationFooter />
            <SubscribeFooter />
          </Row>
          <Row bottom>
            <FooterBackToTop />
            <FooterCopyright />
          </Row>
          {/* <Row>
            <NavigationFooter />
            <FooterCopyright />
          </Row>
          <Row bottom>
            <SubscribeFooter />
            <FooterBackToTop />
          </Row> */}
        </Mobile>
      </Container>
    </BackgroundContainer>
  )
})
